import styled from 'styled-components/macro';
import React from 'react';
import { Box } from 'components/Box';

export const Separator = styled(({ bg, ...rest }) => <Box {...rest} />)(p => ({
  height: '0.0625rem',
  width: '100%',
  backgroundColor: p.bg ? p.theme.colors[p.bg] : p.theme.colors.purpleTrans10
}));
